<template>
  <div>
    <bd-table-list
      :breadcrumb="breadcrumb"
      ref="resource"
      title="Mandats créés par un créancier nécessitant une vérification"
      subtitle="Recherche de mandats"
      autocomplete_idHistory="warrants"
      autocomplete_field="creancier.nom_soc || mandat.ID"
      bdTable="mandat__to_check"
      :actions="actions"
      :fields="fields"
      :Api="Api"
      @row-clicked="selectRow"
      @loaded="refreshRoute"
    >
      <template v-slot:menu>
        <b-row class="mb-3">
          <b-col lg="12">
            
            <b-button
              v-if="$store.getters.isAdmin"
              variant="secondary"
              :to="{ name: 'addWarrantsPayments' }"
              class="mr-2"
              size="sm"
              icon
              title="Réceptionner des paiements"
              ><b-icon-credit-card-fill></b-icon-credit-card-fill
            ></b-button>
            <b-button-group class="mr-2">
              <b-button
                @click="createRoute"
                v-if="$store.getters.getRoute.length !== 0"
                variant="info"
                size="sm"
                title="Créer un itinéraire"
              >
                <b-icon v-if="!computeRoute" icon="geo-alt-fill"></b-icon>
                <b-icon v-else icon="arrow-clockwise" animation="spin"></b-icon>
                ({{ $store.getters.getRoute.length }})
              </b-button>
              <b-button
                size="sm"
                @click="deleteRoute"
                v-if="$store.getters.getRoute.length > 0"
                variant="danger"
              >
                <b-icon icon="x"></b-icon>
              </b-button>
            </b-button-group>

          </b-col>
        </b-row>
      </template>
      <template v-slot:cell(ID)="data">
        <b-link :to="{ name: 'warrantView', params: { id: data.item.ID } }">
          {{ data.item.ID }}
        </b-link>
      </template>
      <template v-slot:cell(realCreancier_nom_soc)="data">
        <b-link
          :to="{ name: 'creditorView', params: { id: data.item.creancierID } }"
        >
          {{ data.item.realCreancier_nom_soc }}
        </b-link>
      </template>
      <template v-slot:cell(debiteur)="data">
        <b-link
          :to="{ name: 'debtorView', params: { id: data.item.debiteurID } }"
        >
          {{ completeName(data.item) }}
        </b-link>
      </template>
      <template v-slot:cell(email)="data">
        <b-link active target="_blank" :href="'mailto:' + data.item.email">
          {{ data.item.email.toLowerCase() }}
        </b-link>
      </template>
    </bd-table-list>
    <b-modal size="xl" id="google-route" hide-footer>
      <template #modal-title>Tournée négociateur</template>
      <GoogleRoute :data="googleData"></GoogleRoute>
    </b-modal>
  </div>
</template>

<script>
import BdTableList from "@/components/BdTableList";
import GoogleRoute from "@/components/GoogleRoute";
import String from "@/services/String.js";
import DateTime from "@/services/DateTime.js";
import warrants from "@/services/warrants.js";
import gestion from "@/services/gestion.js";
export default {
  name: "ManageWarrantsToCheck",
  components: {
    BdTableList,
    GoogleRoute
  },
  data() {
    return {
      Api: gestion.warrants_to_check,
      googleData: {},
      urlGoogleMaps: null,
      computeRoute: false,
      selectedWarrants: [],

      breadcrumb: [
        {
          text: "Gestion",
          to: { name: "home" },
        },
        {
          text: "Mandats nécessitant une vérification",
          active: true,
        },
      ],
      actions: [
        {
          label: "Éditer",
          to: "warrantEdit",
          icon :"pencil-square",
          variant: "success"
        },
      ],
      fields: [
       {
          key: "ID",
          label: "#",
          sortable: true,
          class: "text-center",
          thStyle: { width: "100px" },
        },
        {
          key: "date_ouverture",
          label: "Date d'ouverture",
          sortable: true,
          formatter: (value) => this.toDate(value),
          thStyle: { width: "100px" },
        },

        {
          key: "realCreancier_nom_soc",
          label: "Créancier",
          class: 'text-truncate',
          sortable: true,
        },
        {
          key: "debiteur",
          label: "Débiteur",
          sortable: true,
          class : 'text-truncate'
        },
        {
          key: "email",
          label: "Courriel du débiteur",
          sortable: true,
          class: "text-truncate"
        },
        {
          key: "negotiateurID",
          label: "Négo",
          class: "text-center",
          sortable: true,
          thStyle: { width: "5%" },
        },

        {
          key: "actions",
          label: "Actions",
          sortable: false,
          thStyle: { width: "100px" },
          class: "text-center"
        },
      ],
    };
  },
  methods: {
    completeName(item) {
      let a = "";
      if (item.nom_soc) {
        a += item.nom_soc;
      }
      if (item.nom && item.nom_soc) {
        a += " (" + item.prenom + " " + item.nom + ")";
      } else if (!item.nom_soc) {
        a += item.prenom + " " + item.nom;
      }
      return a;
    },
    deleteRoute() {
      this.$store.commit("deleteRoute");
      this.urlGoogleMaps = "";
      this.refreshRoute();
    },
    refreshRoute() {
      let routes = this.$store.getters.getRoute;
      this.$refs.resource.rows.forEach((el, index) => {
        if (routes.includes(el.ID)) {
          this.$refs.resource.rows[index]._rowVariant = "success";
        } else {
          this.$refs.resource.rows[index]._rowVariant = null;
        }
      });
    },
    selectRow(row) {
      //this.warrants[index]._rowVariant = 'success';
      this.urlGoogleMaps = null;
      const id = row.ID;
      this.$store.commit("toggleRoute", id);
      this.refreshRoute();

      //this.selectedWarrants = payload;
    },

    company(str) {
      return String.company(str);
    },
    toDate(d) {
      return DateTime.humanDate(d);
    },
    createRoute() {
      this.computeRoute = true;
      this.urlGoogleMaps = null;
      warrants
        .routes({
          nego: this.$store.getters.getKeycloak.me.ID,
          ids: this.$store.getters.getRoute,
        })
        .then((response) => {
          this.computeRoute = false;
          if (response.statusText == "OK" && response.data.url) {
            this.urlGoogleMaps = response.data.url;
            this.googleData = response.data;
            this.$bvModal.show("google-route");
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>